<template>
  <v-container>
    <v-row 
      v-if="isTokenValid === false"
      align="center"
      justify="center"
    >
      <p class="red-text fs-15">Aucune demande de réinitialisation de mot de passe n'a été effectuée</p>
    </v-row>
    <v-row
      v-else-if="isTokenValid === true"
      align="center"
      justify="center"
      class="login-container">
      <v-col 
        xs="10"
        sm="8"
        md="5"
        lg="4"
      >
        <h2>Modifier votre mot de passe</h2>
        <form>

          <v-text-field
            v-model="password"
            :append-icon="showPw1 ? 'mdi-eye' : 'mdi-eye-off'"
            :error-messages="passwordErrors"
            :type="showPw1 ? 'text' : 'password'"
            label="Mot de passe"
            @click:append="showPw1 = !showPw1"
            required
            @blur="$v.password.$touch()"
            @keyup.enter="submit"
          ></v-text-field>

          <v-text-field
            v-model="repeatPassword"
            :append-icon="showPw2 ? 'mdi-eye' : 'mdi-eye-off'"
            :error-messages="repeatPasswordErrors"
            :type="showPw2 ? 'text' : 'password'"
            label="Répéter le mot de passe"
            @click:append="showPw2 = !showPw2"
            required
            @blur="$v.repeatPassword.$touch()"
            @keyup.enter="submit"
          ></v-text-field>

          <v-btn 
            class="mr-4 success float-right" 
            @click="submit"
            :disabled="$v.$invalid"
          >
            <v-icon 
              class="mr-2"
              style="font-size: 13px;"
            >
              mdi-check
            </v-icon>
            Définir le mot de passe
          </v-btn>

          <span class="red-text">{{ errors }}</span>

        </form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  // LIBRARY
  import { validationMixin } from 'vuelidate'
  import { required, sameAs, minLength } from 'vuelidate/lib/validators'
  // EVENTS
  import { EventBus } from '@/main.js'
  import { AUTH_CHANGE_PSWD, AUTH_CHECK_TOKEN } from '@/store/actions/auth'
  import { LOADING, LOADED } from '@/store/actions/general'

  export default {
    name: 'Reset',

    mixins: [validationMixin],

    data: () => ({
      password: '',
      repeatPassword: '',
      token: '',
      isTokenValid: null,
      showPw1: false,
      showPw2: false,
      errors: '',
    }),

    validations: {
      password: { 
        required,
        minLength: minLength(8),
      },
      repeatPassword: {
        sameAsPassword: sameAs('password')
      },
    },

    methods: {
      submit () {
        this.errors = ''
        this.dialog      = true
        this.$v.$touch()
        if (this.$v.$invalid) {
          this.submitStatus = ''
        } else {
          this.changePassword()
        }
      },
      checkTokenValidity() {
        EventBus.$emit(LOADING, 'Vérification du jeton...')
        const { token } = this
        this.$store
          .dispatch(AUTH_CHECK_TOKEN, token)
          .then(data => {
            EventBus.$emit(LOADED)
            this.isTokenValid = data.isTokenValid
          })
          .catch(error => {
            EventBus.$emit(LOADED)
            this.isTokenValid = false
            if (error.response) {
              this.errors = error.response.data.error
            } else if (error.request) {
              this.errors = error.request
            } else {
              this.errors = error.message
            }
          })
      },
      changePassword() {
        EventBus.$emit(LOADING, 'Changement du mot de passe...')
        const { password, token } = this
        this.$store
          .dispatch(AUTH_CHANGE_PSWD, { password, token })
          .then(() => {
            EventBus.$emit(LOADED)
            this.$router.push({
              name: 'Login',
            })
          })
          .catch(error => {
            if (error.response) {
              this.errors = error.response.data.error
            } else if (error.request) {
              this.errors = error.request
            } else {
              this.errors = error.message
            }
            EventBus.$emit(LOADED)
          })
      }
    },

    computed: {
      passwordErrors() {
        const errors = []
        
        if (!this.$v.password.$dirty) return errors

        if (!this.$v.password.required) {
          errors.push('Veuillez renseigner un mot de passe')
        }
        
        if (!this.$v.password.minLength) {
          errors.push('Le mot de passe doit être de 8 caractères minimum')
        }

        return errors
      },
      repeatPasswordErrors() {
        const errors = []
        if (!this.$v.repeatPassword.$dirty) return errors
        !this.$v.repeatPassword.sameAsPassword && errors.push('Les mots de passe doivent être identiques')        
        return errors
      },
    },

    mounted() {
      EventBus.$emit(LOADED)
      this.token = this.$route.params.token
      this.checkTokenValidity()
    }
  }
</script>

<style scoped>
  .red-text {
    color: red;
  }
  .login-logo {
    width: 100px;
    height: 100px;
  }
  .login-container {
    height: 500px;
  }

  @media (min-width: 900px) {
    .login-logo {
      width: 200px;
    }
    .login-container {
      height: 600px;
    }
  } 
</style>